module.exports = __webpack_public_path__ + "img/r9.8f1fbbc1.png";